import { render, staticRenderFns } from "./SettingsEditorBase.vue?vue&type=template&id=3073c01f&"
import script from "./SettingsEditorBase.vue?vue&type=script&lang=js&"
export * from "./SettingsEditorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3073c01f')) {
      api.createRecord('3073c01f', component.options)
    } else {
      api.reload('3073c01f', component.options)
    }
    module.hot.accept("./SettingsEditorBase.vue?vue&type=template&id=3073c01f&", function () {
      api.rerender('3073c01f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsEditorBase.vue"
export default component.exports